import type { SemanticCOLORS, SemanticICONS } from "simplydo/react/ui";

export const ROLE_EDITOR_ICON_OPTIONS: SemanticICONS[] = [
  "star",
  "rocket",
  "trophy",
  "certificate",
  "diamond",
];

export const ROLE_EDITOR_COLOR_OPTIONS: SemanticCOLORS[] = [
  "red",
  "orange",
  "yellow",
  "olive",
  "green",
  "teal",
  "blue",
  "violet",
  "purple",
  "pink",
];

export const SEMANTIC_UI_COLOR_NAME_MAP = {
  red: "#e74c3c",
  orange: "#e67e22",
  yellow: "#f39c12",
  olive: "#b5cc18",
  green: "#27ae60",
  teal: "#16a085",
  blue: "#3498db",
  violet: "#9b59b6",
  purple: "#8e44ad",
  pink: "#e91e63",
  brown: "#795548",
  grey: "#95a5a6",
  black: "#000000",
  white: "#ffffff",
} as const;
